import { useState, useEffect } from 'react'
import { adminAPI } from '../../services/api'

function Stepper({ agente, field, value, lo, hi, onStep }) {
  return (
    <div className="inline-flex items-center border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden">
      <button onClick={() => onStep(agente, field, -1, lo, hi)} className="px-2.5 py-1 text-gray-500 hover:bg-gray-50 dark:hover:bg-surface-dark-hover" aria-label="menos">−</button>
      <span className="px-3 py-1 text-sm font-medium w-10 text-center">{value}</span>
      <button onClick={() => onStep(agente, field, 1, lo, hi)} className="px-2.5 py-1 text-gray-500 hover:bg-gray-50 dark:hover:bg-surface-dark-hover" aria-label="mas">+</button>
    </div>
  )
}

export default function RescheduleConfigPanel() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState(null)

  useEffect(() => {
    adminAPI.getRescheduleConfig()
      .then(setRows)
      .catch(() => setMsg('Error al cargar la configuración'))
      .finally(() => setLoading(false))
  }, [])

  function step(agente, field, delta, lo, hi) {
    setRows(prev => prev.map(r => r.agente === agente
      ? { ...r, [field]: Math.min(hi, Math.max(lo, (r[field] || 0) + delta)) } : r))
  }

  async function save() {
    setSaving(true); setMsg(null)
    try {
      const saved = await adminAPI.saveRescheduleConfig(rows)
      setRows(saved)
      setMsg('Guardado ✓')
    } catch {
      setMsg('Error al guardar')
    } finally {
      setSaving(false)
    }
  }

  if (loading) return <div className="p-6 text-sm text-gray-500">Cargando…</div>

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h2 className="text-lg font-medium mb-1">Agendamiento inteligente — config por agente</h2>
      <p className="text-sm text-gray-500 mb-1">Tope de rescatados por día y horizonte de reparto. Los fines de semana siempre se omiten.</p>
      <p className="text-xs text-gray-400 mb-4">Sin configurar = 6 por día · 14 días.</p>

      <div className="flex items-center gap-3 px-1 pb-2 border-b border-gray-200 dark:border-gray-700 text-xs text-gray-400">
        <span className="flex-1">Agente</span>
        <span className="w-28 text-center">Tope por día</span>
        <span className="w-28 text-center">Horizonte (días)</span>
      </div>

      {rows.map(r => (
        <div key={r.agente} className="flex items-center gap-3 px-1 py-2 border-b border-gray-100 dark:border-gray-800">
          <span className="flex-1 text-sm">{r.agente}</span>
          <div className="w-28 flex justify-center">
            <Stepper agente={r.agente} field="maxPerDay" value={r.maxPerDay} lo={1} hi={30} onStep={step} />
          </div>
          <div className="w-28 flex justify-center">
            <Stepper agente={r.agente} field="horizonDays" value={r.horizonDays} lo={1} hi={60} onStep={step} />
          </div>
        </div>
      ))}

      <div className="flex items-center justify-end gap-3 mt-4">
        {msg && <span className="text-xs text-gray-500">{msg}</span>}
        <button onClick={save} disabled={saving} className="px-3.5 py-1.5 text-sm bg-primary-600 text-white rounded-lg hover:bg-primary-700 disabled:opacity-50">
          {saving ? 'Guardando…' : 'Guardar cambios'}
        </button>
      </div>
    </div>
  )
}
